<template>
  <div class="user-outer">
    <div class="user-inner">
      <div class="user-header">
        <div class="logo" @click="goHome()">
          <img src="/logo.png" />
          <span>首页</span>
        </div>
        <span class="title">个人账号设置</span>
      </div>
      <a-form :form="form" v-if="userInfo != null && !isUpdate">
        <ul class="user-info">
          <!-- LOGO -->
          <li v-if="userInfo.accRole && (isSchool || isInstitution)">
            <span class="key">LOGO:</span>
            <span class="value avatar">
              <c-upload
                accept="image/*"
                ossType="avatar"
                :isSingle="true"
                @uploadSuccess="uploadSuccess"
                :sourceFileList="sourceFileList"
              ></c-upload>
            </span>
          </li>
          <!-- 课程方种类 -->
          <li v-if="userInfo.accRole && isInstitution">
            <span class="key">课程方种类：</span>
            <span class="value">
              {{
                userInfo.institutionType == 1
                  ? '社会企业'
                  : userInfo.institutionType == 2
                  ? '个人老师'
                  : userInfo.institutionType == 3
                  ? '高校与协会'
                  : ''
              }}
            </span>
          </li>
          <!-- 课程方名称 -->
          <li v-if="userInfo.accRole && isInstitution">
            <span class="key">课程方名称：</span>
            <span class="value">
              <a-form-item>
                <a-input
                  type="text"
                  v-decorator="[
                    'institutionName',
                    {
                      rules: [
                        {
                          required: true,
                          pattern: /^.{2,45}$/,
                          message: '请输入长度为2~45位的课程方名字',
                        },
                      ],
                      validateTrigger: 'change',
                    },
                  ]"
                />
              </a-form-item>
            </span>
          </li>
          <!-- 学校名称 -->
          <li v-if="userInfo.accRole && isSchool">
            <span class="key">学校名称：</span>
            <span class="value">
              <a-form-item>
                <a-input
                  type="text"
                  v-decorator="[
                    'schoolName',
                    {
                      rules: [
                        {
                          required: true,
                          pattern: /^.{2,75}$/,
                          message: '请输入长度为2~75位的学校名称',
                        },
                      ],
                      validateTrigger: 'change',
                    },
                  ]"
                />
              </a-form-item>
            </span>
          </li>
          <!-- 咨询电话 -->
          <li v-if="userInfo.accRole && isInstitution">
            <span class="key">咨询电话：</span>
            <span class="value">
              <a-form-item>
                <a-input type="text" v-decorator="['phone']" />
              </a-form-item>
            </span>
          </li>
          <!-- 设置密码 -->
          <span
            class="update-password"
            @click="isUpdate = true"
            v-if="userInfo"
            >{{ userInfo.hasPwd == '0' ? '设置密码' : '修改密码' }}</span
          >
          <!-- 用户名 -->
          <li>
            <span class="key">用户名：</span>
            <span class="value">{{ userInfo.username || '未设置用户名' }}</span>
          </li>
          <!-- 手机号 -->
          <li>
            <span class="key">手机号：</span>
            <span class="value">{{ userInfo.mobile || '未设置手机号' }}</span>
          </li>
          <!-- 姓名 -->
          <li>
            <span class="key">姓名：</span>
            <span class="value">{{ userInfo.nickname || '未设置姓名' }}</span>
          </li>
          <!-- 角色 -->
          <li>
            <span class="key">角色：</span>
            <span class="value">{{ userInfo.accRole.roleName }}</span>
          </li>
          <li v-if="userInfo.accRole && isSchool">
            <span class="key">学校属性：</span>
            <span class="value">{{
              userInfo.grandAndType.schoolAttributeTagNames
                ? userInfo.grandAndType.schoolAttributeTagNames
                : ''
            }}</span>
          </li>
          <li v-if="userInfo.accRole && isSchool">
            <span class="key">学校类型：</span>
            <span class="value">{{
              userInfo.grandAndType.schoolTypeTagNames
                ? userInfo.grandAndType.schoolTypeTagNames.toString()
                : ''
            }}</span>
          </li>
          <!-- 创建时间 -->
          <li>
            <span class="key">创建时间：</span>
            <span class="value">{{ userInfo.gmtCreate }}</span>
          </li>
          <!-- 简介 -->
          <li v-if="userInfo.accRole && (isSchool || isInstitution)">
            <span class="key">简介：</span>
            <span class="value">
              <a-form-item>
                <a-textarea
                  placeholder="请输入"
                  :autosize="{ minRows: 3, maxRows: 6 }"
                  v-decorator="[
                    'intro',
                    {
                      validateTrigger: 'blur',
                    },
                  ]"
                  :maxLength="2000"
                />
              </a-form-item>
            </span>
          </li>
          <li v-if="userInfo.institutionType == 3">
            <span class="key">背景图片:</span>
            <span>
              <c-upload
                class="backgroundImage"
                accept="image/*"
                :imageMatchWidth="1125"
                :imageMatchHeight="375"
                :maxFileSize="2097152"
                :maxlength="1"
                :isSingle="true"
                @uploadSuccess="uploadSuccessBackgroundImg"
                :sourceFileList="sourceFileListBackgroundImg"
              ></c-upload>
            </span>
          </li>
          <!-- 确认修改 -->
          <li
            class="update-user"
            v-if="userInfo.accRole && (isSchool || isInstitution)"
          >
            <a-button type="primary" @click="updateUser()">确认修改</a-button>
          </li>
        </ul>
      </a-form>

      <a-form
        class="user-info"
        layout="horizontal"
        :form="form"
        v-if="isUpdate"
      >
        <!-- 请输入旧密码 -->
        <a-form-item
          label="请输入旧密码"
          v-if="userInfo.hasPwd != '0'"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-input
            type="password"
            placeholder="请输入"
            v-decorator="[
              'oldPassword',
              { rules: [{ required: true, message: '请输入旧密码' }] },
            ]"
          />
        </a-form-item>

        <!-- 请输入新密码 -->
        <a-form-item
          label="请输入新密码"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-input
            type="password"
            placeholder="请输入"
            v-decorator="[
              'password',
              { rules: [{ required: true, message: '请输入新密码' }] },
            ]"
          />
        </a-form-item>

        <!-- 重复新密码 -->
        <a-form-item
          label="重复新密码"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-input
            type="password"
            placeholder="请输入"
            v-decorator="[
              'repeatPassword',
              { rules: [{ required: true, message: '重复新密码' }] },
            ]"
          />
        </a-form-item>

        <a-form-item class="update-oper">
          <a-button
            type="primary"
            @click="confirmUpdate()"
            style="margin-right: 18px"
            >确认修改</a-button
          >
          <a-button type="primary" @click="isUpdate = false">返回</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
import user from '../../api/user'

import school from '../../api/school'

import institution from '../../api/institution'

import CUpload from '../../components/CUpload'

export default {
  name: 'userCenter',
  data() {
    return {
      form: this.$form.createForm(this),
      userInfo: null,
      isUpdate: false, //是否修改密码
      avatarUrl: '',
      sourceFileList: [],
      isSchool: false, //角色是学校
      isInstitution: false, //角色是课程方
      intro: false, //简介
      backgroundImg: '',
      sourceFileListBackgroundImg: [],
    }
  },
  components: {
    CUpload,
  },
  methods: {
    //头像上传成功之后回调
    uploadSuccess(url) {
      this.avatarUrl = url
    },
    uploadSuccessBackgroundImg(url) {
      this.backgroundImg = url
    },

    //修改用户信息
    updateUser() {
      let req = {
        imgUrl: this.avatarUrl || this.sourceFileList[0],
        backgroundImg:
          this.backgroundImg || this.sourceFileListBackgroundImg[0],
      }
      this.form.validateFields((err, value) => {
        if (!err) {
          if (this.isSchool) {
            req.id = this.userInfo.schoolId
            req.schoolName = value.schoolName.trim()
            if (!req.schoolName.length) {
              this.$message.error('学校名称不能为空')
              return
            }
          } else {
            req.id = this.userInfo.institutionId
            req.institutionName = value.institutionName
            req.phone = value.phone
          }
          req.intro = value.intro
          console.log('req', req)
          user.updateUserCenterInfo(req).then((res) => {
            this.$message.success('修改成功')
            this.$set(this.userInfo, 'hasPwd', '1')
          })
        }
      })
    },

    init() {
      //如果是学校
      // if(this.userInfo.)
    },

    goHome() {
      this.$router.push('courseList')
    },

    //确认修改
    confirmUpdate() {
      this.form.validateFields((err, value) => {
        if (!err) {
          if (value.password != value.repeatPassword) {
            this.$message.error('两次密码输入值不同，请确认密码')
          } else {
            delete value.repeatPassword
            value.userId = this.userInfo.id
            user.updatePassword(value).then((res) => {
              this.$message.success('修改成功')
              this.isUpdate = false
            })
          }
        }
      })
    },
  },
  created() {
    let self = this
    this.$store.commit('USERINFO', null)
    this.$store.dispatch('getUserInfo').then((res) => {
      console.log('res', res)
      this.userInfo = res
      this.isSchool = this.userInfo.accRole.id == '3'
      this.isInstitution = this.userInfo.accRole.id == '4'
      if (this.isSchool) {
        this.sourceFileList.push(this.userInfo.schoolImgUrl)
        setTimeout(() => {
          self.form.setFieldsValue({
            schoolName: self.userInfo.schoolName,
            intro: self.userInfo.intro,
          })
        }, 100)
      } else if (this.isInstitution) {
        setTimeout(() => {
          self.form.setFieldsValue({
            institutionName: self.userInfo.institutionName,
            phone: self.userInfo.phone,
            intro: self.userInfo.intro,
          })
        }, 100)
        this.sourceFileList.push(this.userInfo.institutionImgUrl)
        this.sourceFileListBackgroundImg.push(this.userInfo.backgroundImg)
      }
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.user-outer {
  margin: 0px auto;
  padding-top: 100px;
  text-align: center;
}
.user-inner {
  width: 500px;
  display: inline-block;
}
.user-header {
  text-align: left;
  padding: 0px 6px 18px;
  position: relative;
  .logo {
    display: inline-block;
    position: relative;
    padding-right: 10px;
    cursor: pointer;
    img {
      width: 38px;
      height: auto;
      margin-right: 6px;
      vertical-align: middle;
    }
    span {
      font-size: 20px;
      font-weight: 600;
      vertical-align: middle;
    }
  }
  .logo::after {
    content: '';
    width: 1px;
    height: 16px;
    position: absolute;
    top: 11px;
    right: 0px;
    background: $normal-color-disabled;
  }
  .title {
    vertical-align: middle;
    display: inline-block;
    padding-left: 10px;
    font-weight: 600px;
    font-size: 16px;
  }
}
.user-info {
  padding: 40px 0px;
  border: 1px solid $border-color;
  text-align: left;
  position: relative;
  li {
    margin: 15px 0px !important;
    font-size: 16px;
    line-height: 36px;
    .key {
      display: inline-block;
      width: 140px;
      text-align: right;
      vertical-align: top;
    }
    .value {
      vertical-align: top;
      padding-left: 10px;
      display: inline-block;
      padding-right: 16px;
      text-align: left;
      textarea {
        vertical-align: top;
        min-width: 300px;
      }
      input {
        min-width: 200px;
      }
    }
    .avatar {
      vertical-align: top;
    }
  }
  .update-oper {
    text-align: center;
  }
  .update-user {
    text-align: center;
  }
}
.update-password {
  color: $primary-color-dark;
  cursor: pointer;
  position: absolute;
  top: 62px;
  right: 30px;
}
//背景图
/deep/ .backgroundImage {
  display: inline-block;
  margin-left: 2px;
}
/deep/ .backgroundImage .ant-upload {
  width: 250px;
  height: 84px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .backgroundImage .ant-spin-nested-loading {
  width: 250px;
}
/deep/ .backgroundImage .ant-upload-list-picture-card-container {
  width: 250px;
  height: 84px;
  border: 0;
}
/deep/ .backgroundImage .ant-upload-list-item {
  width: 250px;
  height: 84px;
  border: 0;
}
/deep/ .backgroundImage .image-upload {
  width: 250px;
  height: 84px;
  border: 0;
}
</style>
